import React from "react";
import { Link } from "react-router-dom";
import sec2left from "../Assets/sec2left.webp";
import sec5 from "../Assets/sec5.webp";
import footerpic from "../Assets/footerpic.webp";
import logo from "../Assets/logo.svg";

const Homepage = () => {
  return (
    <>
     <section class="container-fluid sec1">
      <div class="custom-container">
        <div class="col-xl-12 col-lg-12 col-md-12 col-12 text-center pt-5 pb-5">
          <img
            src={logo}
            alt="Parul University Logo"
            class="logo-img"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
          <h5>10th ke baad kya?</h5>
          <h1 class="fw-bold text-danger">
            CONFUSION KO CHHODO,
            <br />
            FUTURE KA SOCHO!
          </h1>
          <Link to="#">
            Download free guide <span class="ms-2">&#8681;</span>
          </Link>
        </div>
      </div>
    </section>

      <section class="container-fluid sec2">
        <div class="custom-container">
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <img src={sec2left} alt="Parul University Logo" />
            </div>
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 sec2R">
              <p>Future secure karna hai, but</p>
              <h2>Kaunsa option best rahega,</h2>
              <p>ye sochke tension badhta hai, right?</p>
            </div>
          </div>
        </div>
      </section>

      <section class="container-fluid sec3">
        <div class="custom-container">
          <h2>
            Sabse smart choice? – <span>DIPLOMA!</span>
          </h2>
          <p class="text-center">
            Jab sab traditional streams ki baat karte hain, tab Diploma ek
            practical aur career-focused choice ban sakta hai! Kyuki Diploma ke
            sath aap sirf padhai nahi karte, aap seekhte ho real-world skills
            aur industry-ready training{" "}
            <strong>jo jaldi job tak pahunchne</strong> ka raasta kholti hai.
          </p>
          <p class="text-center">
            Agar aap bhi <strong>job-oriented aur skill-based career</strong> ki
            soch rahe ho, toh <strong>ye FREE guide aapke liye hai!</strong>
          </p>
        </div>
      </section>
      <section class="container-fluid sec4">
        <div class="custom-container">
          <div class="row sec4inside">
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 box1">
                <p>
                  Best Diploma Courses
                  <br />
                  After 10th
                </p>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 box1">
                <p>
                  Best Diploma Courses
                  <br />
                  After 10th
                </p>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 box1">
                <p>
                  Best Diploma Courses
                  <br />
                  After 10th
                </p>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 box1 mb-0">
                <p>
                  Best Diploma Courses
                  <br />
                  After 10th
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <Link to="#" class="mt-5 mb-5">
              Download Now <span class="ms-2">&#8681;</span>
            </Link>
          </div>
        </div>
      </section>
      <section class="container-fluid sec5">
        <div class="custom-container">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <h2>Diploma kyu?</h2>
              <h3>Fast-Track Career Growth Without the Wait!</h3>

              <ul>
                <li>
                  <strong>Short Duration</strong> 2-3 saal me career readyt
                </li>
                <li>
                  <strong>High Demand</strong> Companies diploma holders ko hire
                  karti hain
                </li>
                <li>
                  <strong>Hands-on Learning</strong> Sirf theory nahi, practical
                  skills bhi
                </li>
                <li>
                  <strong>Affordable</strong> Degree se cost-effective aur jaldi
                  ROI
                </li>
              </ul>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-centre">
              <img src={sec5} alt="Parul University Logo" />
            </div>
          </div>
        </div>
      </section>
      <section class="container-fluid sec7">
        <div class="custom-container sec7inside">
          <div class="row">
            <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
              &nbsp;
            </div>
            <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12 sec7Right">
              <h3>Ye opportunity miss mat karo!</h3>
              <h2>Apne career ki strong shuruaat yahin se karo!</h2>
              <h4>
                FREE Guide <span>Download Karo!</span>
              </h4>
              <Link to="#" class="mt-5 mb-5">
                Download Now <span class="ms-2">&#8681;</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section class="container-fluid sec6">
        <div class="row">
          <img src={footerpic} alt="Parul University Logo" class="w-100" />
        </div>
      </section>
    </>
  );
};

export default Homepage;
